import Appsignal from "@appsignal/javascript"
import { getMetaContent } from "./meta"

const key = getMetaContent("appsignal-api-key")

const appsignal = key
  ? new Appsignal({
      key,
      revision: getMetaContent("version"),
      ignoreErrors: [
        // https://github.com/react-native-webview/react-native-webview/issues/2680
        /window\.ReactNativeWebView\.postMessage is not a function/,
        // EOL Safari
        /Can't find variable: IntersectionObserver/,
        /\.requestSubmit is not a function/
      ]
    })
  : null

export default appsignal
